import { ClassList } from "./ClassList";
import { LayoutEntity } from "./Definitions";
import { Dimension as Padding, PlaneDimensions, dimensionClassMap, planeDimensionsClass } from "./Dimension";
import { MediaSpecific, mediaSpecificClassO } from "./Media";
import css from "./Styles/padding.module.scss";

export { Padding };

export type Paddings = PlaneDimensions<Padding>;
export type LayoutPaddings = LayoutEntity<Paddings, "paddings">;

const paddingClass = (side: string, padding: Padding | undefined, suffix: string): string | undefined => padding !== undefined ? css[`p${side}-${dimensionClassMap[padding]}${suffix}`] : undefined;

export const paddingsClass = (paddings?: Paddings): ClassList => planeDimensionsClass(paddings, (side, padding) => paddingClass(side, padding, ""));

export const paddingsClassMS = (paddings?: MediaSpecific<Paddings>): ClassList =>
    mediaSpecificClassO(paddings, (paddings, suffix) => planeDimensionsClass(paddings, (side, padding) => paddingClass(side, padding, suffix)));

export const paddingsClassMSL = (paddings?: MediaSpecific<LayoutPaddings>): ClassList =>
    mediaSpecificClassO(paddings, (layout, suffix) => planeDimensionsClass(layout.paddings, (side, padding) => paddingClass(side, padding, suffix)));
